import VueRouter, { RouteConfig } from 'vue-router'

const Rules = () => import('../activity/fission/Rules.vue')
const Withdraw = () => import('../activity/fission/Withdraw.vue')
const Invitation = () => import('../activity/fission/Invitation.vue')
const InvitationRecords = () => import('../activity/fission/InvitationRecords.vue')

export const fissionActivityRoute: RouteConfig = {
  path: '/fission-activity',
  name: 'fission_activity',
  redirect: '/fission-s3-activity',
}

export const fissionActivityRulesRoute: RouteConfig = {
  path: '/fission-activity-rules',
  name: 'fission_activity_rules',
  component: Rules,
  meta: {
    title: '活动规则',
  },
}

export const fissionActivityWithdrawRoute: RouteConfig = {
  path: '/fission-activity-withdraw',
  name: 'fission_activity_withdraw',
  component: Withdraw,
  meta: {
    title: '提现',
  },
}

export const fissionActivityInvitationRoute: RouteConfig = {
  path: '/fission-activity-invitation',
  name: 'fission_activity_invitation',
  component: Invitation,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '天天跳绳',
  },
}

export const fissionActivityInvitationRecordsRoute: RouteConfig = {
  path: '/fission-activity-invitation-records',
  name: 'fission_activity_invitation_records',
  component: InvitationRecords,
  meta: {
    title: '邀请记录',
  },
}

export default [
  fissionActivityRoute,
  fissionActivityRulesRoute,
  fissionActivityWithdrawRoute,
  fissionActivityInvitationRoute,
  fissionActivityInvitationRecordsRoute,
]

export function navigateToFissionActivity(router: VueRouter) {
  router.push({ name: fissionActivityRoute.name })
}

export function navigateToFissionActivityRules(router: VueRouter) {
  router.push({ name: fissionActivityRulesRoute.name })
}

export function navigateToFissionActivityWithdraw(router: VueRouter) {
  router.push({ name: fissionActivityWithdrawRoute.name })
}

export function navigateToFissionActivityInvitation(router: VueRouter) {
  router.push({ name: fissionActivityInvitationRoute.name })
}

export function navigateToFissionActivityInvitationRecords(router: VueRouter) {
  router.push({ name: fissionActivityInvitationRecordsRoute.name })
}
